export default __webpack_public_path__ + "static/media/hvac_02.d368e0d7.jpg";